import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
    { label: 'About us',    to: '/analytics-cup#about' },
    { label: 'Editions',    to: '/analytics-cup#editions' },
    { label: 'Submissions', to: '/analytics-cup/submissions' },
    { label: 'Videos',      to: '/analytics-cup/videos' },
    { label: 'Contact',     to: '/analytics-cup#contact' },
];

const EDITION_2_PATH = '/analytics-cup/editions/analytics-cup2';

export const AnalyticsCupNav = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const closeMenu = () => setMenuOpen(false);
    const isOnEdition2 = location.pathname.startsWith(EDITION_2_PATH);

    return (
        <header className={`ac-nav ${menuOpen ? 'is-open' : ''}`}>
            <div className="container">
                <div className="ac-nav__inner">

                    {/* Hamburger — left, mobile only */}
                    <button
                        className={`ac-nav__toggle ${menuOpen ? 'is-open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle navigation"
                        aria-expanded={menuOpen}
                    >
                        <span />
                        <span />
                        <span />
                    </button>

                    {/* Brand */}
                    <Link to="/analytics-cup" className="ac-nav__brand" onClick={closeMenu}>
                        <span className="ac-nav__brand-name">Analytics Cup</span>
                    </Link>

                    {/* Desktop links */}
                    <nav className="ac-nav__links">
                        {NAV_LINKS.map(({ label, to }) => (
                            <Link key={label} to={to} className="ac-nav__link" onClick={closeMenu}>
                                {label}
                            </Link>
                        ))}
                    </nav>

                    {/* CTA — right, always visible */}
                    {!isOnEdition2 && (
                        <Link to={EDITION_2_PATH} className="ac-nav__cta" onClick={closeMenu}>
                            Analytics Cup 2.0
                        </Link>
                    )}
                </div>
            </div>

            {/* Mobile fullscreen overlay */}
            <div className={`ac-nav__overlay ${menuOpen ? 'is-open' : ''}`} aria-hidden={!menuOpen}>
                <nav className="ac-nav__overlay-links">
                    {NAV_LINKS.map(({ label, to }) => (
                        <Link key={label} to={to} className="ac-nav__overlay-link" onClick={closeMenu}>
                            {label}
                        </Link>
                    ))}
                </nav>
                <Link to={EDITION_2_PATH} className="ac-nav__overlay-cta" onClick={closeMenu}>
                    Analytics Cup 2.0
                    <span>Register your interest →</span>
                </Link>
            </div>
        </header>
    );
};
